// extracted by mini-css-extract-plugin
export default {"container":"Demo_container__Rnbb-"};